module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 4
// module chunks = 0 1 2 3